import { Icon } from 'bd-web-components'
import { DashboardGenericCardLocal } from '../DashboardGenericTotalCard/index'
import { formatCurrencyBRL } from '../../utils/format-currency-without-rs'

interface TotalizerData {
  tickets: number
  totalAccesses: number
  totalTickets: number
  totalValue: number
}

interface AccessAndSalesTotalizersProps {
  type: string
  isMobile: boolean
  totalizerTableData: TotalizerData
}

export function AccessAndSalesTotalizers({
  type,
  isMobile,
  totalizerTableData,
}: AccessAndSalesTotalizersProps) {
  return (
    <div
      style={{
        maxWidth: '850px',
      }}
    >
      {type === 'access' && (
        <DashboardGenericCardLocal
          variateCardDescriptionText="Total de acessos"
          variateValue={formatCurrencyBRL(
            totalizerTableData.totalAccesses,
            true,
            '.',
            true
          )}
          isMonetaryValue={false}
        >
          <Icon
            fill="#000000"
            classes="question-circle-help-center"
            iconName="dashboardCourtesy"
            width={isMobile ? 0 : 27}
            height={isMobile ? 0 : 23}
          />
        </DashboardGenericCardLocal>
      )}
      {type === 'sales' && (
        <>
          <DashboardGenericCardLocal
            variateCardDescriptionText="Total de vendido"
            variateValue={formatCurrencyBRL(
              totalizerTableData.totalTickets,
              true,
              '.',
              true
            )}
            isMonetaryValue={false}
          >
            <Icon
              fill="#0d0d0d"
              classes="question-circle-help-center"
              iconName="dashboardTicket"
              width={isMobile ? 0 : 27}
              height={isMobile ? 0 : 23}
            />
          </DashboardGenericCardLocal>
          <br />
          <DashboardGenericCardLocal
            variateCardDescriptionText="Total de receita"
            variateValue={formatCurrencyBRL(totalizerTableData.totalValue)}
            isMonetaryValue={false}
          >
            <Icon
              fill="#000000"
              classes="question-circle-help-center-sumary"
              iconName="dashboardMoney"
              width={isMobile ? 0 : 27}
              height={isMobile ? 0 : 23}
            />
          </DashboardGenericCardLocal>
        </>
      )}
    </div>
  )
}
